import { forwardRef, useImperativeHandle } from 'react';
import { createZodFormResolver, useFormControls } from '@mews/framework';
import { SchemaFormFields } from '@mews-commander/form';
import { BillNameFormValues, billNameSchema, billNameFormDefinition } from './schema';

interface Props {
    handleSubmit: (values: BillNameFormValues) => Promise<void>;
    defaultValues?: BillNameFormValues;
    closeDialog: () => void;
}

export const BillNameDialogForm = forwardRef(
    ({ handleSubmit, defaultValues = { name: '' }, closeDialog }: Props, ref) => {
        const { renderFormContent, submit } = useFormControls<BillNameFormValues>({
            resolver: createZodFormResolver(billNameSchema),
            onSubmit: async (values) => {
                await handleSubmit(values);
                closeDialog();
            },
            defaultValues,
        });

        useImperativeHandle(
            ref,
            () => ({
                submit,
            }),
            [submit]
        );

        return renderFormContent(<SchemaFormFields schema={billNameSchema} formDefinition={billNameFormDefinition} />);
    }
);
